import { certificateHtml } from "../user/certificateHtml";

const founderSectionHtml = (program) => {
    if (program.certificateDescription) return `<li class="dynamic-list-item"><b>${program.programName} -</b> ${program.certificateDescription}</li>`;
    return `<li class="dynamic-list-item"><b>${program.programName}</b></li>`
}

const badgeImage = (image) => {
    return `<img class="badge-image" alt={"badge"} src="${image}" />`
}

const ledgerProgramOnlyHeader = () => {
    return ` <tr>
<th>Program Name</th>
<th>Program Date</th>
<th>Credits Earned</th>
</tr>`
}

const ledgerProgramEventHeader = () => {
    return `  <tr>
<th>Program Name</th>
<th>Event Name</th>
<th>Event Date</th>
<th>Credits Earned</th>
</tr>`
}

const ledgerProgramOnlyRow = (row) => {
    return ` <tr>
    <td>${row.programName}</td>
    <td>${row.programDate}</td>
    <td>${row.credits}</td>
    </tr>`
}

const ledgerProgramEventRow = (row) => {
    return ` <tr>
        <td>${row.programName}</td>
        <td>${row.eventName}</td>
        <td>${row.eventDate}</td>
        <td>${row.credits}</td>
    </tr>`
}

function getElementHeight(html) {
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = html;
    document.body.appendChild(tempDiv);
    const height = tempDiv.offsetHeight;
    document.body.removeChild(tempDiv);
    return height;
}

function getBadgedSectionHtml() {
    return `<h4 class="badge-heading">Badged! Championing > 25 Hours</h4>
    <div class="badge-images" id="badge-images">

    </div>`
}

export const generateHtmlForPdf = async (data, user, programView) => {

    const basicHtml = certificateHtml(user);
    const parser = new DOMParser();
    let doc = parser.parseFromString(basicHtml, "text/html");
    const maxNumberOfFoundedProgs = 3;
    let maxNumberOfVolunteeredProgs = 6;
    const maxNumberOfBadges = 4;

    const foundedPrograms = data.founded_programs;
    const volunteeredPrograms = data.programs;
    const badgedPrograms = data.badged_programs;

    const founderSection = doc.getElementById('founder-section');
    const volunteerSection = doc.getElementById('volunteer-section');
    const badgedSection = doc.getElementById('badge-section');
    let badgedImages;
    const ledgerTable = doc.getElementById('ledger-table');
    const ledgerHead = doc.querySelector('#ledger thead'); // Get the thead element

    for (let i = 0; i < maxNumberOfFoundedProgs; i++) {
        if (foundedPrograms[i]) {

            if (i === 0) {
                founderSection.innerHTML += `<h4 class="dynamic-heading"><b>${user.first_name}</b> is the founder of</h4><ul>`;
            }

            founderSection.innerHTML += founderSectionHtml(foundedPrograms[i]);

            if (i === maxNumberOfFoundedProgs - 1 || !foundedPrograms[i + 1]) {
                founderSection.innerHTML += `</ul>`;
            }
        }
    }

    if (foundedPrograms.length < maxNumberOfFoundedProgs) {
        maxNumberOfVolunteeredProgs += maxNumberOfFoundedProgs - foundedPrograms.length
    }

    for (let i = 0; i < maxNumberOfVolunteeredProgs; i++) {
        if (volunteeredPrograms[i]) {

            if (i === 0) {
                volunteerSection.innerHTML += `<h4 class="dynamic-heading"><b>${user.first_name}</b> has been a key champion in</h4><ul>`;
            }

            volunteerSection.innerHTML += founderSectionHtml(volunteeredPrograms[i]);

            if (i === maxNumberOfVolunteeredProgs - 1 || !volunteeredPrograms[i + 1]) {
                volunteerSection.innerHTML += `</ul>`;
            }

        }
    }

    if (badgedPrograms.length > 0) {
        badgedSection.innerHTML = getBadgedSectionHtml();
        badgedImages = doc.getElementById('badge-images');
    }

    for (let i = 0; i < maxNumberOfBadges; i++) {
        if (badgedPrograms[i]) {
            badgedImages.innerHTML += badgeImage(badgedPrograms[i].badge);
        }
    }

    const dataForLedger = programView ? data.programs : data.events;

    const headerRow = programView ? ledgerProgramOnlyHeader() : ledgerProgramEventHeader();

    const rowFunction = programView ? ledgerProgramOnlyRow : ledgerProgramEventRow;

    // Append header to thead once
    ledgerHead.innerHTML = headerRow;

    for (let i = 0; i < dataForLedger.length; i++) {
        const rowHtml = rowFunction(dataForLedger[i]);
        ledgerTable.innerHTML += rowHtml;
    }

    return doc
}